
import { Box, Card, CardContent, Divider, IconButton, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ContentCopy, Delete } from "@mui/icons-material";
import QuestionnaireFormActionToolbar from "./QuestionnaireFormActionToolbar";

const QuestionnaireFormTitleDescription = ({
  sectionIndex,
  formInfo,
  updateFormTitle,
  isMainForm,
  onFocusTitle,
  handleAddQuestion,
  handleAddSection,
  handleAddFreeText,
  activeToolbarKey,
  error,
  handleDuplicateSection,
  handleDeleteSection

}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Box sx={{ position: "relative" }}  >
      <Card
        sx={{
          borderRadius: 1.5,
          mb: 3,
          borderTop: isMainForm ? `8px solid ${theme.palette.secondary.main}` : "none",
          border: error
            ? `1px solid ${theme.palette.error.main}`
            : "1px solid transparent",
        }}
      >
        <CardContent>
          <TextField
            fullWidth
            variant="standard"
            placeholder={isMainForm ? t('questionnaire.form.title') : t('questionnaire.form.sectionTitle')}
            value={formInfo.title}
            onChange={(e) => updateFormTitle({ title: e.target.value })}
            onFocus={onFocusTitle}
          />
          <TextField
            fullWidth
            variant="standard"
            placeholder={
              isMainForm ? t('questionnaire.form.description') : t('questionnaire.form.sectionDescription')
            }
            value={formInfo.description}
            onChange={(e) => updateFormTitle({ description: e.target.value })}
            onFocus={onFocusTitle}
            sx={{ mt: 2 }}
          />
          <Divider sx={{ mt: 2 }} />

          {!isMainForm && (
            <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
              <Tooltip title={t('general.copy')}>
                <IconButton onClick={handleDuplicateSection}>
                  <ContentCopy fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title={t('general.delete')}>
                <IconButton onClick={handleDeleteSection}>
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          )}

        </CardContent>
        {error &&
          <Typography color="error" variant="body2" sx={{ m: 1 }}>{error}</Typography>
        }
      </Card>

      {sectionIndex == activeToolbarKey && <QuestionnaireFormActionToolbar
        onAddQuestion={handleAddQuestion}
        onAddSection={handleAddSection}
        onAddFreeText={handleAddFreeText}
      />
      }

    </Box>
  );
};

export default QuestionnaireFormTitleDescription;
